module.exports = __webpack_public_path__ + "../resources/img/warning_circle.20422f8d.svg";